import {
    Grid,
    TextField
} from '@material-ui/core';
import { HorizontalLayout } from '@styles/spacing-styles';
import { themeProvider } from '@swipejobs/frontend-theme-provider';
import * as React from 'react';
import MaskedInput from 'react-text-mask';
import styled, { css } from 'styled-components';

export const HorizontalLayoutRow = styled(HorizontalLayout)`
  display: flex;
  flex-direction: row;
`;

export const SectionBox = styled.div`
  border: 1px solid black;
  background-color: #D9D9D9;
  padding: 6px;
`;

export const SectionHeading = styled.span`
  font-size: ${() => themeProvider.getTypography().font.size.extraLargeMedium};
`;

export const SectionSubHeading = styled.span`
  font-size: ${() => themeProvider.getTypography().font.size.large};
  font-weight: bold;
`;

export const SectionSubtitle = styled.span<{ emphasise?: boolean; }>`
  font-style: italic;
  ${({ emphasise }) => emphasise === true ? css`font-weight: bold` : ''};
`;

export const FormSectionDivider = styled.div`
  height: 20px;
  background-color: #323232;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const BorderedGrid = styled(Grid)`
  border-width: 2px 0 0 2px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.3);
`;

export const BorderedGridItem = styled(Grid).attrs(props => ({
    item: true,
    container: props.container ?? true,
    direction: props.direction ?? 'column'
}))`
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.3);
  padding: 4px 7px;
  border-width: 0 2px 2px 0;
  min-width: 0;
  display: flex;
`;

export const ReadonlyFieldLabel = styled.div`
  font-size: ${() => themeProvider.getTypography().font.size.small};
  min-width: 0;
  min-height: 30px;
`;

export const ReadonlyFieldValue = styled.div<{ fontStyle?: React.CSSProperties['fontStyle']; disableFlex?: boolean }>`
  font-weight: bold;
  overflow-wrap: break-word;
  font-size: ${() => themeProvider.getTypography().font.size.normal};
  flex: ${({ disableFlex }) => disableFlex ? '0 0 auto' : '1'};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 18px;
  max-width: 100%;
  ${({ fontStyle }) => fontStyle ? `font-style: ${fontStyle}` : ''};
  
  > * {
    font-weight: bold;
    font-size: ${() => themeProvider.getTypography().font.size.normal};
  }
`;

export const MaskedLabel = styled(MaskedInput).attrs({
    disabled: true
})`
  border: 0;
  background: unset;
  margin: 0;
  padding: 0;
  color: ${() => themeProvider.getColors().title.defaultColor};
`;

const applyFormFieldBase = css`
  font-size: 1rem;
  padding: 13px 14px;
  border: 1px solid gray;
  border-radius: 4px;
  min-height: 49px;
`;

export const PrefilledFormField = styled.span<{
    wrapContents?: boolean;
    constrainToParent?: boolean;
    boldContent?: boolean;
    useFullWidth?: boolean;
}>`
  ${applyFormFieldBase};
  display: block;
  background-color: #ccc;
  ${({ useFullWidth }) => useFullWidth && css`width: 100%;`};
  ${({ wrapContents }) => wrapContents !== true && css`
    max-height: 50px; 
    white-space: nowrap; 
    overflow: auto;
  `};
  ${({ constrainToParent }) => constrainToParent === true && css`max-width: 100%`};
  ${({ boldContent }) => boldContent === true && css`font-weight: bold`};
`;

export const EditableFormField = styled.input<{
    constrainToParent?: boolean;
    matchParentWidth?: boolean;
}>`
  ${applyFormFieldBase};
  background-color: #fff;
  font-weight: bold;
  ${({ matchParentWidth }) => matchParentWidth === true && css`width: 100%`};
  ${({ constrainToParent }) => constrainToParent === true && css`max-width: 100%`};
`;

export const TextFormField = styled(TextField)`
  && {
    ${applyFormFieldBase};
    box-sizing: border-box;
    font-weight: bold;
  }
`;

export const SpacedPrefilledFormField = styled(PrefilledFormField)`
  margin: 5px 10px;
`;



// WEBPACK FOOTER //
// ./src/containers/form-i9/styles.tsx